import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const SellerDisclosure = () => {
  return (
    <View>
      <Text style={styles.title}>Seller Disclosure</Text>
      <Text style={styles.list}>
        Seller knows of no facts materially affecting the value of the Real
        Property which are not readily observable and which have not been
        disclosed to Buyer. Except as provided for in the preceding sentence,
        Seller extends and intends no warranty and makes no representation of
        any type, either express or implied, as to the physical condition or
        history of the Property. Except as otherwise disclosed in writing Seller
        has received no written or verbal notice from any governmental entity or
        agency as to a currently uncorrected building, environmental or safety
        code violation.
      </Text>
    </View>
  );
};

export default SellerDisclosure;
